import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import AdminMode from './components/AdminMode';
import MatchdaySplash from './components/MatchdaySplash';
import HomePage from './pages/HomePage';
import HistoryPage from './pages/HistoryPage';
import StandingsPage from './pages/StandingsPage';
import SquadPage from './pages/SquadPage';
import { storage } from './utils/storage';
import './App.css';

function AppContent() {
  const [, setIsAdmin] = useState(storage.isAdminMode());
  const location = useLocation();
  const isHistoryPage = location.pathname === '/gecmis';

  useEffect(() => {
    // Uygulama başlığını her zaman "LONCA APP" olarak ayarla
    document.title = 'LONCA APP';
    
    // Cache'i başlat
    storage.initializeCache();
    
    // Favicon'u yükle (admin panelden ayarlanmışsa)
    const loadFavicon = async () => {
      try {
        const settings = await storage.getAdminSettings();
        if (settings.faviconUrl) {
          // Mevcut favicon linkini bul veya oluştur
          let faviconLink = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
          if (!faviconLink) {
            faviconLink = document.createElement('link');
            faviconLink.rel = 'icon';
            document.head.appendChild(faviconLink);
          }
          faviconLink.href = settings.faviconUrl;
          console.log('[App] Favicon güncellendi:', settings.faviconUrl);
        }
      } catch (error) {
        console.error('[App] Favicon yükleme hatası:', error);
      }
    };
    
    loadFavicon();
  }, []);

  useEffect(() => {
    // İlk oyuncuları oluştur (sadece oyuncu yoksa)
    const initializePlayers = async () => {
      const players = await storage.getPlayers();
      if (players.length === 0) {
        const initialPlayers = [
          { id: 'player-1', name: 'Oğuzhan', position: 'MDO', code: '#oğuzhan', playerCards: [], stats: {} },
          { id: 'player-2', name: 'Burak', position: 'MOO', code: '#burak', playerCards: [], stats: {} },
          { id: 'player-3', name: 'Anıl', position: 'MO', code: '#anıl', playerCards: [], stats: {} },
          { id: 'player-4', name: 'Serhat', position: 'KL', code: '#serhat', playerCards: [], stats: {} },
          { id: 'player-5', name: 'Ercan', position: 'KL', code: '#ercan', playerCards: [], stats: {} },
          { id: 'player-6', name: 'Okan', position: 'STP', code: '#okan', playerCards: [], stats: {} },
          { id: 'player-7', name: 'Sadettin', position: 'STP', code: '#sadettin', playerCards: [], stats: {} },
          { id: 'player-8', name: 'Fırat', position: 'MOO', code: '#fırat', playerCards: [], stats: {} },
          { id: 'player-9', name: 'Furkan', position: 'MO', code: '#furkan', playerCards: [], stats: {} },
          { id: 'player-10', name: 'Murat', position: 'MDO', code: '#murat', playerCards: [], stats: {} },
          { id: 'player-11', name: 'Mehmet', position: 'SNT', code: '#mehmet', playerCards: [], stats: {} },
          { id: 'player-12', name: 'Berat', position: 'SNT', code: '#berat', playerCards: [], stats: {} },
          { id: 'player-13', name: 'Kazım', position: 'SNT', code: '#kazım', playerCards: [], stats: {} },
          { id: 'player-14', name: 'İsmail', position: 'MO', code: '#ismail', playerCards: [], stats: {} },
          { id: 'player-15', name: 'Ertuğrul', position: 'STP', code: '#ertuğrul', playerCards: [], stats: {} },
          { id: 'player-16', name: 'Tugay', position: 'STP', code: '#tugay', playerCards: [], stats: {} },
        ];
        await storage.savePlayers(initialPlayers);
      }
    };
    initializePlayers();
  }, []);

  return (
    <div className="App">
      <MatchdaySplash />
      {isHistoryPage && <AdminMode onToggle={setIsAdmin} showLockButton={true} />}
      {!isHistoryPage && <AdminMode onToggle={setIsAdmin} showLockButton={false} />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/gecmis" element={<HistoryPage />} />
        <Route path="/puan-durumu" element={<StandingsPage />} />
        <Route path="/kadro" element={<SquadPage />} />
      </Routes>
      <Navigation />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;



